// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-top-navbar-container {
  width: 100%;
  background-color: #fff;
}
@media (orientation: landscape) and (min-width: 768px) {
  .mobile-top-navbar-container .safeArea {
    margin-left: calc(var(--sar, 0px) / 1.5);
    margin-right: calc(var(--sar, 0px) / 1.5);
  }
}
.mobile-top-navbar-container .mobile-top-navbar {
  color: var(--text-color);
  display: flex;
  z-index: 1;
  overflow-x: auto;
  gap: 0.8rem;
}
.mobile-top-navbar-container .mobile-top-navbar::-webkit-scrollbar {
  display: none;
}
.mobile-top-navbar-container .mobile-top-navbar .mobile-keyword-top {
  border: 1px solid var(--ion-color-secondary);
  border-radius: 6px;
  display: flex;
  padding: 0.4rem;
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
}
.mobile-top-navbar-container .mobile-top-navbar .mobile-keyword-top:first-child {
  margin-left: 10px;
}
.mobile-top-navbar-container .mobile-top-navbar .mobile-keyword-top p {
  font-weight: bold;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  line-height: 12.88px;
  white-space: nowrap;
  color: var(--text-color);
  transition: color 0.3s ease;
  text-transform: lowercase;
}
.mobile-top-navbar-container .mobile-top-navbar .mobile-keyword-top p:first-letter {
  text-transform: uppercase;
}
.mobile-top-navbar-container .mobile-top-navbar .keywords-isactive {
  background-color: var(--ion-color-secondary);
}
.mobile-top-navbar-container .mobile-top-navbar .keywords-isactive p {
  color: var(--ion-color-light) !important;
}

.mobile-bottom-nav {
  position: sticky;
  bottom: 0px;
  padding: 0px 16px;
  min-height: 80px;
  background: var(--ion-color-secondary);
}
.mobile-bottom-nav .bottom-nav-container {
  display: flex;
  color: #A1CCEE;
  font-size: 0.7rem;
  gap: 1rem;
  width: 100%;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .bottom-icon {
  margin-top: calc(var(--vh, 1vh) * 1);
  height: 25px;
  width: 25px;
  background-color: #A1CCEE;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-position: center;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .bottom-icon-selected {
  background-color: white;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .selected {
  color: white;
  border-radius: 2px;
  font-weight: bold;
  white-space: nowrap;
}
.mobile-bottom-nav .bottom-nav-container .mobile-keyword .label {
  margin-top: 5px;
  padding: 1px 3px;
  font-weight: bold;
  font-size: 10px;
  white-space: nowrap;
}

.sticky {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

ion-tab-bar {
  margin-top: -1px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/navbar/mobile-navbar.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,sBAAA;AACF;AACI;EADF;IAEI,wCAAA;IACA,yCAAA;EAEJ;AACF;AAAE;EACE,wBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AAEJ;AAAI;EACE,aAAA;AAEN;AACI;EACE,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AACN;AACM;EACE,iBAAA;AACR;AAEM;EACE,iBAAA;EACA,qCAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;AAAR;AAEQ;EACE,yBAAA;AAAV;AAKI;EACE,4CAAA;AAHN;AAKM;EACE,wCAAA;AAHR;;AASA;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,sCAAA;AANF;AAQE;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AANJ;AAQI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AANN;AAQM;EACE,oCAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;AANR;AASM;EACE,uBAAA;AAPR;AAUM;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AARR;AAUM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AARR;;AAcA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,wCAAA;AAXF;;AAcA;EACE,gBAAA;AAXF","sourcesContent":[".mobile-top-navbar-container {\n  width: 100%;\n  background-color: #fff;\n  .safeArea {\n    @media (orientation: landscape) and (min-width: 768px) {\n      margin-left: calc(var(--sar, 0px) / 1.5);\n      margin-right: calc(var(--sar, 0px) / 1.5);\n    }\n  }\n  .mobile-top-navbar {\n    color: var(--text-color);\n    display: flex;\n    z-index: 1;\n    overflow-x: auto;\n    gap: 0.8rem;\n  \n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .mobile-keyword-top {\n      border: 1px solid var(--ion-color-secondary);\n      border-radius: 6px;\n      display: flex;\n      padding: 0.4rem;\n      margin-top: 0.4rem;\n      margin-bottom: 0.4rem;\n\n      &:first-child {\n        margin-left: 10px;\n      }\n\n      p {\n        font-weight: bold;\n        font-family: 'Montserrat', sans-serif;\n        font-size: 14px;\n        line-height: 12.88px;\n        white-space: nowrap;\n        color: var(--text-color);\n        transition: color 0.3s ease;\n        text-transform: lowercase;\n        \n        &:first-letter {\n          text-transform: uppercase;\n        }\n      }\n    }\n\n    .keywords-isactive {\n      background-color: var(--ion-color-secondary);\n      \n      p {\n        color: var(--ion-color-light) !important;\n      }\n    }\n  }\n}\n\n.mobile-bottom-nav {\n  position: sticky;\n  bottom: 0px;\n  padding: 0px 16px;\n  min-height: 80px;\n  background: var(--ion-color-secondary);\n\n  .bottom-nav-container {\n    display: flex;\n    color: #A1CCEE;\n    font-size: 0.7rem;\n    gap: 1rem;\n    width: 100%;\n\n    .mobile-keyword {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      flex-grow: 1;\n\n      .bottom-icon {\n        margin-top: calc(var(--vh, 1vh) * 1);\n        height: 25px;\n        width: 25px;\n        background-color:#A1CCEE;\n        mask-repeat: no-repeat;\n        mask-position: center;\n        -webkit-mask-position: center;\n      }\n\n      .bottom-icon-selected {\n        background-color: white;\n      }\n\n      .selected {\n        color: white;\n        border-radius: 2px;\n        font-weight: bold;\n        white-space: nowrap;\n      }\n      .label {\n        margin-top: 5px;\n        padding: 1px 3px;\n        font-weight: bold;\n        font-size: 10px;\n        white-space: nowrap;\n      }\n    }\n  }\n}\n\n.sticky {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\nion-tab-bar{\n  margin-top: -1px;;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
